import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template146: Tren para excursiones desde Seúl (Transporte.jsx)
// Contenido desde page (texts, canvasImages). Sin fallbacks.
const Template146 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const fortalezaImage = getCanvasImageUrl("fortaleza");
	const logoImage = getCanvasImageUrl("logo");

	const intro = page?.texts?.[1]?.content;
	const ktxSrt = page?.texts?.[2]?.content;
	const suwon = page?.texts?.[3]?.content;
	const nami = page?.texts?.[4]?.content;
	const dmz = page?.texts?.[5]?.content;
	const consejosTitle = page?.texts?.[6]?.content;
	const consejosContent = page?.texts?.[7]?.content;

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const boxStyle = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "center",
		gap: "10px",
		border: "2px solid #d9e6de",
	};

	const boxHighlightStyle = {
		backgroundColor: "#caeae6",
		border: "3px solid #2e8b80",
		borderRadius: "12px",
		padding: "12px 14px",
		fontSize: 13,
		fontFamily: "'Poppins', sans-serif",
		color: "#333",
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
		lineHeight: 1.5,
	};

	const h4Style = {
		margin: 0,
		marginBottom: "8px",
		fontSize: 13,
		fontWeight: 700,
		color: "#2e8b80",
		textTransform: "uppercase",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{intro && (
				<Box
					data-block-id="text-1"
					sx={{
						padding: "16px",
						fontSize: 13,
						color: "#444",
						position: "relative",
					}}
				>
					<Box
						component="p"
						sx={p}
						dangerouslySetInnerHTML={{ __html: intro }}
					/>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 20px",
					fontSize: 13,
					color: "#444",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					flex: 1,
				}}
			>
				{ktxSrt && (
					<Box data-block-id="text-2" sx={boxStyle}>
						<Box sx={{ fontSize: 18 }}>🚄</Box>
						<Box
							sx={{ fontSize: 13, color: "#444" }}
							dangerouslySetInnerHTML={{ __html: ktxSrt }}
						/>
					</Box>
				)}

				{suwon && (
					<Box data-block-id="text-3" sx={{ ...boxStyle, position: "relative", marginBottom: 5 }}>
						<Box sx={{ fontSize: 18 }}>🏯</Box>
						<Box
							sx={{ fontSize: 13, color: "#444" }}
							dangerouslySetInnerHTML={{ __html: suwon }}
						/>
						{fortalezaImage && (
							<Box
								sx={{
									alignSelf: "center",
									marginTop: 1,
									position: "absolute",
									right: 0,
									bottom: isSmallScreen ? -80 : -60,
								}}
							>
								<img
									src={fortalezaImage}
									alt="Fortaleza Hwaseong"
									style={{ width: 90, opacity: 0.9 }}
								/>
							</Box>
						)}
					</Box>
				)}

				{nami && (
					<Box data-block-id="text-4" sx={boxStyle}>
						<Box sx={{ fontSize: 18 }}>🏝️</Box>
						<Box
							sx={{ fontSize: 13, color: "#444" }}
							dangerouslySetInnerHTML={{ __html: nami }}
						/>
					</Box>
				)}

				{dmz && (
					<Box data-block-id="text-5" sx={boxStyle}>
						<Box sx={{ fontSize: 18 }}>🚧</Box>
						<Box
							sx={{ fontSize: 13, color: "#444" }}
							dangerouslySetInnerHTML={{ __html: dmz }}
						/>
					</Box>
				)}

				{(consejosTitle || consejosContent) && (
					<Box data-block-id="text-6" sx={boxHighlightStyle}>
						{consejosTitle && (
							<Box component="h4" sx={h4Style}>
								{consejosTitle}
							</Box>
						)}
						{consejosContent && (
							<Box
								sx={{ fontSize: 13, color: "#333", lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: consejosContent }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template146.thumbnail = "/images/template-1.png";

export default Template146;
